import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import InlineSVG from 'svg-inline-react';
import PasswordMask from 'react-password-mask';

import { loginCheck, forgotPassword } from '../../../store/modules/login';
import { addFeedback } from '../../../store/modules/feedback';
import classes from './Login.scss';
import logo from '../../../assets/logo_login.svg';
import eye from '../../../styles/assets/ic_pw_reveal.svg';
import FeedbackProvider from '../../../components/FeedbackProvider/FeedbackProvider';

const style = {
  backgroundColor: 'pink',
  width: '100%',
  maxWidth: 360,
  margin: '0 auto',
  height: 48,
};

const queryString = () => {
  // This function is anonymous, is executed immediately and
  // the return value is assigned to queryString!
  const string = {};
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    // If first entry with this name
    if (typeof string[pair[0]] === 'undefined') {
      string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof string[pair[0]] === 'string') {
      const arr = [string[pair[0]], decodeURIComponent(pair[1])];
      string[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      string[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  return queryString;
};

class Login extends React.Component {
  constructor(props) {
    super(props);

    // console.log(props);

    let forgot = false;
    if (typeof props.location.query.forgot !== 'undefined') {
      forgot = props.location.query.forgot;
    }

    this.state = {
      email: '',
      password: '',
      forgot,
      forgotSubmitted: false,
      didFail: props.login.didFail,
    };

    // const { dispatch } = this.context.store;

    // // console.log('location: ', window.location);

    if (props.login.isAuthenticated) {
      // dispatch(push('/dashboard'));
      window.location = `${window.location.origin}/dashboard`;
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ password: this.password.passwordInput.value });
      this.setState({ email: this.email.value });
    }, 500);
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.context.store;
    // console.log('Login receives', nextProps);
    if (nextProps.login.isAuthenticated) {
      // user is authenticated, perform redirect
      if (nextProps.location.search.length) {
        const queryStrings = queryString(nextProps.location.search);
        if (
          typeof queryStrings.redirect !== 'undefined' &&
          queryStrings.redirect.length
        ) {
          dispatch(push(queryStrings.redirect));
        } else {
          window.location = `${window.location.origin}/dashboard`;
          dispatch(push('/dashboard'));
        }
      } else {
        window.location = `${window.location.origin}/dashboard`;
        dispatch(push('/dashboard'));
      }
    }

    if (nextProps.login.didFail) {
      this.setState({ didFail: nextProps.login.didFail });
      this.props.addFeedback('error', 'Login Daten sind nicht korrekt.');
    }
  }

  checkSubmit = (event, input) => {
    // // console.log('buttonpressed', event);
    this.setState({ didFail: false });
    if (event.keyCode === 13) {
      // // console.log('ENTER!!!');
      this.login();
    } else if (event.target.value.length) {
      if (input === 'email') {
        this.setState({ email: event.target.value });
      } else {
        this.setState({ password: event.target.value });
      }
    }
  };

  login = () => {
    // console.log('trying login');
    if (this.state.forgot) {
      this.props.forgotPassword(this.state.email);
      this.setState({
        forgotSubmitted: !this.state.forgotSubmitted,
      });
    } else {
      this.props.loginCheck(this.state.email, this.state.password);
    }
  };

  render() {
    let linkText = 'Passwort vergessen?';
    let buttonText = 'Anmelden';
    let passwordInput = null;
    let content = null;

    let errorClass = '';
    if (this.state.didFail) {
      errorClass = classes.error;
    }

    if (!this.state.forgotSubmitted) {
      if (this.state.forgot) {
        linkText = 'Zurück zum Login';
        buttonText = 'Passwort zurücksetzen';
      } else {
        /*
        <input
              type='password'
              placeholder='Passwort'
              onChange={event => {
                this.setState({ password: event.target.value });
              }}
              className={errorClass}
              onKeyDown={e => this.checkSubmit(e)}
            />
        */ passwordInput = (
          <div>
            <PasswordMask
              id="password"
              name="password"
              placeholder="Passwort"
              className={classes.passwordMask}
              ref={input => {
                this.password = input;
              }}
              buttonStyles={{
                background: `transparent url(${eye}) center right no-repeat`,
                content: '',
                color: 'transparent',
                right: 20,
              }}
              onChange={e => {
                // this.setState({ password: event.target.value });
                this.checkSubmit(e, 'password');
              }}
              onKeyDown={e => {
                this.checkSubmit(e, 'password');
                // this.setState({ password: event.target.value });
              }}
            />
            <br />
          </div>
        );
      }
      content = (
        <form
          className="comment-form"
          formAction="login"
          onSubmit={event => {
            event.preventDefault();
            this.login();
          }}
        >
          <input
            type="email"
            placeholder="E-Mail-Adresse"
            onChange={e => {
              this.checkSubmit(e, 'email');
              // this.setState({ email: event.target.value });
            }}
            className={errorClass}
            onKeyDown={e => {
              this.checkSubmit(e, 'email');
              // this.setState({ email: event.target.value });
            }}
            ref={input => {
              this.email = input;
            }}
          />
          <br />
          {passwordInput}
          <RaisedButton
            label={buttonText}
            primary
            style={style}
            onClick={() => this.login()}
          />
          <br />
          <br />
          <a
            href="#resetPassword"
            onClick={event => {
              event.preventDefault();
              this.setState({ forgot: !this.state.forgot });
            }}
          >
            {linkText}
          </a>
          <input type="submit" style={{ display: 'none' }} />
        </form>
      );
    } else {
      content = (
        <div>
          <h4>
            Sie finden einen Link zum zurücksetzen
            <br />
            Ihres Kennworts in Ihrem Posteingang.
          </h4>
        </div>
      );
    }
    return (
      <div className={`${classes.login}`}>
        <div className={classes.loginForm}>
          <InlineSVG src={logo} className={classes.logo} />
          <h2>Willkommen bei SiMPL</h2>
          {content}
        </div>
        <FeedbackProvider />
      </div>
    );
  }
}
Login.propTypes = {
  loginCheck: PropTypes.func.isRequired,
  forgotPassword: PropTypes.func.isRequired,
  addFeedback: PropTypes.func.isRequired,
  login: PropTypes.object,
  location: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
};
Login.contextTypes = {
  store: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  login: state.login,
});
const mapActionCreators = {
  loginCheck,
  forgotPassword,
  addFeedback,
};
export default connect(mapStateToProps, mapActionCreators)(Login);



// WEBPACK FOOTER //
// ./src/routes/Login/components/Login.js